export class InternalAppsError extends Error {
  constructor(private readonly originalError: any) {
    super(originalError);
  }
}
